export const BLOCK_COMMAND = 'command';
export const BLOCK_FILE = 'file';
export const BLOCK_PATHS = 'paths';
export const BLOCK_INSTRUCTIONS = 'instructions';
export const BLOCK_NOTE = 'note';
export const BLOCK_WARNING = 'warning';
export const BLOCK_UNSUPPORTED = 'unsupported';

export const BLOCK_TYPES = [
  BLOCK_COMMAND,
  BLOCK_FILE,
  BLOCK_PATHS,
  BLOCK_INSTRUCTIONS,
  BLOCK_NOTE,
  BLOCK_WARNING,
  BLOCK_UNSUPPORTED
];

export const CLIENT_STATUS_SUPPORTED = 'supported';
export const CLIENT_STATUS_UNSUPPORTED = 'unsupported';

export const AUTH_TOKEN = 'tokenAuthentication';
export const AUTH_USER_PASSWORD = 'usernamePassword';

export const AUTHENTICATION_OPTIONS = [
  {
    value: AUTH_TOKEN,
    labelId: 'mcp.auth.token'
  },
  {
    value: AUTH_USER_PASSWORD,
    labelId: 'mcp.auth.userPassword'
  }
];
